'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { find, get, isEmpty, partition } from 'lodash';
import { withRouter } from 'react-router-dom';
import Logger from '../../../utils/Logger';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButton from '../../tag/OTButton';
import Loader from '../../Loader';
import Alert from '../../Alert';
import AppointmentRescheduleConfirmModal from './AppointmentRescheduleConfirmModal';
import {
  getAppointmentRescheduleOptions,
  hideRescheduleModal,
  releaseRescheduleOption,
  requestAppointmentRescheduleOptionsFailed,
  rescheduleAppointment,
  selectAndSubmit,
  selectRescheduleOption,
  showRescheduleModal,
} from '../../../data/appointment/actions';
import { connect } from 'react-redux';
import InvalidArgumentError from '../../../api/InvalidArgumentError';
import { APPOINTMENTS } from '../../../data/reducer';
import ToastHOC from '../../ToastHOC';
import Calendar from '../ReservationCalendar/Calendar';
import { formatCustom } from '../../../utils/TimeUtils';
import OTButtonGroup from '../../tag/OTButtonGroup';
import {
  mapAppointmentsForCalendar,
  mapAppointmentsForList,
  mapRescheduleAppointmentsForList,
  mapRescheduleTimesForCalendar,
  mapSelectedAppointmentForCalendar,
  resolveClinic,
} from '../../../utils/AppointmentUtils';
import ReservationsList from '../ReservationsList';
import ReservationListItem from '../ReservationListItem';
import { getDepartmentDisplay } from '../../../utils/TimelineUtils';
import NoRescheduleTimesAvailableNotification from './NoRescheduleTimesAvailableNotification';

const { id: module_id } = module;
const logger = new Logger(module_id);

class AppointmentReschedule extends React.Component {
  constructor() {
    super();
    this.state = {
      showCalendar: false,
    };
  }

  componentDidMount() {
    let { dispatch } = this.props,
      //verify appointment id form
      appointmentId = get(this.props, 'match.params.appointmentId', null);

    if (!appointmentId || !Number.isInteger(Number.parseInt(appointmentId))) {
      dispatch(
        requestAppointmentRescheduleOptionsFailed(
          new InvalidArgumentError({
            code: 'INVALID_APPOINTMENT_ID',
            msg: 'Appointment id is invalid: must be a number',
          })
        )
      );
      return;
    }

    dispatch(getAppointmentRescheduleOptions(appointmentId));
  }

  componentDidUpdate(oldProps) {
    let { isFetching: newIsFetching } = this.props;
    let { isFetching: oldIsFetching } = oldProps;
    let { data } = this.props;

    if (oldIsFetching && !newIsFetching) {
      if (data && data.filter((item) => !item.original).length >= 7) {
        this.setState({
          showCalendar: true,
        });
      }
    }
  }

  choose = (item) => {
    let { dispatch } = this.props;
    dispatch(selectRescheduleOption(item.dateStart));
  };

  release = (item) => {
    let { dispatch } = this.props;
    dispatch(releaseRescheduleOption());
  };

  submit = () => {
    let { data, dispatch } = this.props;

    let item = data.filter((item) => item.selected)[0];

    if (item.selected && !item.original) {
      logger.debug('submit item: ', item);
      dispatch(showRescheduleModal());
    } else {
      //no change, noop
      logger.debug('submit - no operation, time not changed');
    }
  };

  selectAndSubmit = (item) => {
    let { dispatch } = this.props;
    dispatch(selectAndSubmit(item.dateStart));
  };

  confirmTime = () => {
    let { data, dispatch, history } = this.props;

    let item = data.filter((item) => item.selected);

    if (!(item instanceof Array) || item.length !== 1) {
      throw new Error('ambiguous selection');
    }

    dispatch(rescheduleAppointment(item[0], history));
  };

  closeModal = () => {
    let { dispatch, data } = this.props;
    dispatch(hideRescheduleModal());
    this.selectTime(data.filter((item) => item.original)[0]);
  };

  cancel = () => {
    this.props.history.push(`/appointments`);
  };

  selectTime = (item) => {
    let { dispatch } = this.props;
    dispatch(selectRescheduleOption(item.dateStart));
  };

  render() {
    let {
      isFetching,
      showModal,
      data,
      error,
      isRescheduling,
      toasts,
      originalAppointment,
    } = this.props;
    let info = null,
      selectedSlot = null,
      hasRescheduleOptions = false,
      selectionView = null;

    if (isFetching) {
      info = <Loader />;
    }

    if (error) {
      info = <Alert message={`${module_id}.${error.code}`} />;
    } else if (!isFetching) {
      if (!isEmpty(data.filter((item) => !item.original))) {
        hasRescheduleOptions = true;
        selectedSlot = find(data, (item) => item.selected, null);
        selectionView = this.state.showCalendar ? 'CALENDAR' : 'LIST';
      }
    }

    return (
      <div className="ot-mainview">
        <Row>
          <Span>
            <h1 className="ot-viewtitle">
              <FormattedMessage id={`${module_id}.title`} />
            </h1>
          </Span>
        </Row>
        {(toasts || info) && (
          <Row>
            <Span>
              {toasts.map((item) => (
                <Alert {...item.spec} />
              ))}
              {info}
            </Span>
          </Row>
        )}
        {originalAppointment && (
          <Row>
            <Span>
              <h2 className="inline-label uppercase">
                <FormattedMessage id={`${module_id}.current.time`} />
              </h2>

              <ul className="appointment-container">
                <ReservationListItem item={originalAppointment}>
                  <span>
                    {getDepartmentDisplay(originalAppointment.location)}
                  </span>
                </ReservationListItem>
              </ul>
            </Span>
          </Row>
        )}
        {selectionView && (
          <Row>
            <Span>
              <h2 className="inline-label uppercase">
                <FormattedMessage
                  id={`${module_id}.select.time.${selectionView}`}
                />
              </h2>
            </Span>
          </Row>
        )}
        {
          //show this part only if items exist
          selectionView === 'LIST' && (
            <ReservationsList
              selectAndSubmit={this.selectAndSubmit}
              data={mapRescheduleAppointmentsForList(data)}
            />
          )
        }
        {selectionView === 'CALENDAR' && (
          <Calendar
            selectTime={this.selectTime}
            selectedTime={
              selectedSlot && mapSelectedAppointmentForCalendar(selectedSlot)
            }
            data={mapRescheduleTimesForCalendar(data)}
          />
        )}
        {hasRescheduleOptions && (
          <Row>
            <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
              <OTButton onClick={this.cancel} color={'gray'} message={'back'} />
              {selectionView === 'CALENDAR' && (
                <OTButton
                  disabled={!selectedSlot || selectedSlot.original}
                  onClick={this.submit}
                >
                  <FormattedMessage id={'reserve.appointment'} />
                  {selectedSlot && !selectedSlot.original && (
                    <span className={'screen-reader-only'}>
                      {formatCustom(
                        selectedSlot.dateStart,
                        'DD.MM.YYYY [klo] HH:mm - '
                      ) + formatCustom(selectedSlot.dateEnd, 'HH:mm')}
                    </span>
                  )}
                </OTButton>
              )}
            </OTButtonGroup>
          </Row>
        )}
        {!hasRescheduleOptions && !isFetching && (
          <NoRescheduleTimesAvailableNotification
            clinic={
              originalAppointment && resolveClinic(originalAppointment.location)
            }
          />
        )}

        {hasRescheduleOptions && selectedSlot && (
          <AppointmentRescheduleConfirmModal
            modalIsOpen={showModal}
            isRescheduling={isRescheduling}
            closeModal={this.closeModal}
            confirmTime={this.confirmTime}
            item={selectedSlot}
            orgItem={originalAppointment}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    isFetching,
    isRescheduling,
    showModal,
    data,
    originalAppointment,
    error,
  } = state[APPOINTMENTS].reschedule;
  return {
    isFetching,
    isRescheduling,
    showModal,
    data,
    error,
    originalAppointment,
  };
};

const toastOptions = {
  module_id: module_id,
  dismissOnUnmount: ['APPOINTMENT_RESCHEDULE_FAILED_TOAST'],
};

export default withRouter(
  connect(mapStateToProps)(ToastHOC(toastOptions, AppointmentReschedule))
);
